<template>
  <div> <!-- Only one element for Transition -->
    <div class="text-center mb-4">
      <small class="text-muted">
        <i class="fa-solid fa-info-circle me-1"></i>
        Pré-Inscriptions - Sélectionnez le nombre de participants pour chaque activité.<br>
        Toute les options seront à valider sur place dès votre arrivée
      </small>
    </div>

    <div v-for="(option,optionIdx) in optionsFields" :key="option.key" class="card mb-4">
      <div class="card-header">
        <h5 class="mb-0">
          <i class="fa-solid fa-star me-2"></i>
          {{ option.value.name }}
        </h5>
      </div>
      <div class="card-body">
        <small v-if="option.value.link" class="text-muted fst-italic d-block mb-3">
          <i class="fa-solid fa-info-circle me-1"></i>
          {{ option.value.linkText ?? 'Plus de détails' }} <a :href="option.value.link" target="_blank">{{ option.value.linkLabel ?? option.value.link }}</a>
        </small>
        <div class="row">
          <div class="col-12" :class="[hasActivitiesPicture(option.value) ? 'col-md-8 mt-1' :'']">
            <div
              v-for="(activity,activityIdx) in option.value.activities"
              :key="activity.id"
              class="mb-2"
              @mouseover="setCurrentActivity(option.value.id, activity)"
            >
              <div
                class="d-flex flex-column flex-sm-row align-items-sm-center p-3 rounded-3 border"
                :class="[activity.participantCount > 0 ? 'border-2 border-primary bg-primary bg-opacity-10' : '']"
                >
                <div class="d-flex justify-content-between col-auto">
                  <SelectInputComponent
                    :value-key="`options[${optionIdx}].activities[${activityIdx}].participantCount`"
                    label=""
                    placeholder=""
                    class="me-3 mb-3 mb-sm-0"
                    :required="false"
                    :options="[...Array(maxParticipants + 1).keys()].map(nbr => ({ value: nbr, label: `${nbr}` }))"
                  />
                  <div class="text-end ms-3 d-sm-none">
                    <span v-if="activity.noPrice" class="badge bg-primary">
                      N.C.
                    </span>
                    <span v-else-if="activity.price > 0" class="badge bg-primary">
                      +{{ activity.price }}€ / pers.
                    </span>
                    <span v-else class="badge bg-success">
                      Inclus
                    </span>
                  </div>
                </div>
                <div class="flex-grow-1">
                  <div class="d-flex justify-content-between align-items-start">
                    <div>
                      <span class="fw-bold mb-1">
                        {{ activity.name }}
                      </span>
                      <p v-if="activity.description" class="text-muted small mb-0 pre-line">
                        {{ activity.description }}
                      </p>
                    </div>
                    <div class="text-end ms-3 d-none d-sm-block">
                      <span v-if="activity.noPrice" class="badge bg-secondary">
                        N.C.
                      </span>
                      <span v-else-if="activity.price > 0" class="badge bg-primary">
                        +{{ activity.price }}€ / pers.
                      </span>
                      <span v-else class="badge bg-success">
                        Inclus
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="hasActivitiesPicture(option.value)"
            class="col-4 mb-2 d-none d-md-block position-relative"
          >
          <div class="position-sticky" style="top: 3rem;">
            <img
              v-if ="_activitiesPicture[option.value.id]"
              :alt="option.value.name"
              :src="getPictureUrl(_activitiesPicture[option.value.id].key, 100,200,true)"
              class="rounded w-100 h-100 object-fit-contain"
            >
            <div v-if="activityDetailsVisible" style="left: 20px; top: 10px; max-width: calc(100% - 80px);" class="bg-white border rounded-1 p-1 bg-opacity-75 position-absolute">
              {{ _activitiesPicture[option.value.id]?.details }}
            </div>
            <div class="position-absolute" style="right: 20px; bottom: 10px;" v-if="_activitiesPicture[option.value.id]?.details" @mouseover="activityDetailsVisible = true" @mouseleave="activityDetailsVisible = false" role="button">
              <span class="fa-stack text-primary">
                <i class="fa-solid fa-circle fa-stack-2x text-white" style="scale: 0.95;"></i>
                <i class="fa-regular fa-circle fa-stack-2x"></i>
                <i class="fa-solid fa-info fa-stack-1x"></i>
              </span>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <PageBottomMessage  message-key="pageOptions"></PageBottomMessage>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useFieldArray } from 'vee-validate';

import { getPictureUrl } from '@/compositions/helper';

const participation = defineModel<UserParticipation>();
const _activitiesPicture = ref<Record<number, { key: string; details: string | null | undefined }>>({});
const activityDetailsVisible = ref(false);

const { fields: optionsFields } = useFieldArray<UserParticipationOption>(() => "options");

const maxParticipants = computed(() => {
  return 1 + (participation.value?.companions?.length ?? 0);
});

const hasActivitiesPicture = (option: UserParticipationOption) => {
  return option.activities?.some(activity => activity.picture?.key);
}

const setCurrentActivity = (optionId: number, activity: UserParticipationOptionActivity) => {
  const activityPicture  = activity.picture?.key;
  if(activityPicture){
    _activitiesPicture.value[optionId] = { key: activityPicture, details: activity.details };
  }
}

onMounted(() => {
  optionsFields.value.forEach(option => {
    const activityWithPicture = option.value.activities?.find(x=>x.picture?.key);
    if(activityWithPicture){
      _activitiesPicture.value[option.value.id] = { key: activityWithPicture.picture!.key, details: activityWithPicture.details };
    }
  });
});
</script>
